// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"db766115","389":"c8e8b24b","453":"5533d5f1","732":"37629ab9","977":"7954fc84"}[chunkId] + ".chunk.js";
};